<template>
    <head>
        <title>{{ $global.appName }}</title>
    </head>
</template>

<script>
export default {
    name: 'Head',
};
</script>

<style scoped></style>
